import productGridImpressions from 'redux/middleware/analytics/actions-to-track/products-and-components/product-grid-impressions';
import { getMealDealProducts } from 'redux/modules/meal-deals/selectors';
import { getCurrentPageDepth } from 'redux/modules/page/selectors';

export default productGridImpressions({
  fetch: getMealDealProducts,
  list: 'mealdeal',
  taxonomy: getCurrentPageDepth,
});
